/*$(document).on('mouseenter', 'input#addToCart', function() {
  $('.pplr-quantity > .pplr-drop-item.active').click();  
  var card_front = $('.pplr-prev-left').children('img').attr('src');
  var front_val = $('#card_front');
  if (front_val.val().length < 10) {
	  front_val.val(card_front);
	  console.log('Front image:', card_front);
  }
  // Wait for back image to load/change
  setTimeout(function () {
	var card_back = $('.pplr-prev-left').children('img').attr('src');
	var back_val = $('#card_back');
	if (back_val.val().length < 10) {
	  back_val.val(card_back);
	  console.log('Back image:', card_back);
	}
  },1500);
});*/





$(document).ready(function() {
  const path = window.location.pathname;
  const acceptBtn = `<label for="accept-btn" style="display:block; margin-bottom:12px; font-size:18px; cursor:pointer;">
                        <input type="checkbox" id="accept-btn" style="width:20px; height:20px; vertical-align:middle; margin-right:8px;">
                        Please confirm all details are correct!
                    </label>`;  
      function uploadImage(callbackField, imgSrc) {
          $('#addToCart').prop('disabled', true).val('Identifying...');
          $.ajax({
              url: 'https://kunalk275.sg-host.com/shopify-app/base64.php',
              type: 'POST',
              data: { imageBase: imgSrc },
              success: function (resp) {
                  $(callbackField).val(resp);

                  // Check if both front & back are ready
                  const frontReady = $('#card_front').val().length > 10;
                  const backReady = $('#card_back').val().length > 10;

                  if (frontReady && backReady) {
                      $('#addToCart').prop('disabled', false).val('Add to Cart');
                  }
              },
              error: function (err) {
                  console.log(err);
                  $('#addToCart').prop('disabled', false).val('Add to Cart');
              }
          });
      }

  if (path !== '/collections/custom/products/business-card') {
    $(document).on('click', '.pplr-quantity, .pplr-quantity- > .pplr-drop-item', function () {
      var card_front = $('.pplr-prev-left').children('img').attr('src');
      var front_val = $('#card_front');
      if (front_val.val().length < 10) {
        //front_val.val(card_front);
        uploadImage('#card_front',card_front);
        console.log('Front image:', card_front);
      }
      // Wait for back image to load/change
      setTimeout(function () {
        var card_back = $('.pplr-prev-left').children('img').attr('src');
        var back_val = $('#card_back');
        if (back_val.val().length < 10) {
          //back_val.val(card_back);
          uploadImage('#card_back',card_back);
          console.log('Back image:', card_back);
        }
      },1500);
    });
  }
  // Business Card Page
  if (path === '/collections/custom/products/business-card') {
    $('input#addToCart').before(acceptBtn);
    $('#addToCart').prop('disabled', true);
    localStorage.setItem('current-class', '');
    $(document).on('click', 'a.js-modal-close.pplr_close', function () {
        setTimeout(() => {
            let imgSrc = $('.pplr-prev-left img').attr('src'); 
            let currentClass = localStorage.getItem('current-class');
            // If no image, skip
            if (!imgSrc) return;

            if (currentClass === 'front-card') {
                uploadImage('#card_front',imgSrc);
            } 
            else if (currentClass === 'back-card') {
                uploadImage('#card_back',imgSrc);
            } 
            else {
                uploadImage('#card_front',imgSrc); // default
            }
            localStorage.setItem('current-class', '');
        }, 1500);
      });
      $(document).on('change','input#accept-btn', function() {
        if ($(this).is(':checked')) {
          $('input#addToCart').prop('disabled', false);
        }else{
          $('input#addToCart').prop('disabled', true);
        }
      });
      $(document).on('click','[name="properties[Front Design Upload]"]',function(){
        var imgClass = localStorage.setItem('current-class','front-card'); 
      });
      $(document).on('click','[name="properties[Back Design Upload]"]',function(){
        var imgClass = localStorage.setItem('current-class','back-card');
      });
  }
  // B&G Business Card Page
  else if (path === '/collections/custom/products/b-g-business-card') {
    $(document).on('click','div[data-pview="mdzrb5v6-yv"]',function(){
      var card_back = $('.pplr-prev-left').children('img').addClass('active-back').removeClass('active-front');
    });
    $(document).on('click','div[data-pview="dS4070Km4I"]',function(){
      var card_front = $('.pplr-prev-left').children('img').addClass('active-front').removeClass('active-back');
    });
    $('input#addToCart').before(acceptBtn);

    //$('#addToCart').prop('disabled', true);
    $(document).on('change','input#accept-btn', function() {
        if ($(this).is(':checked')) {
          if($('.pplr-prev-left').children('img').hasClass('active-front')){
              $('#card_back').val('');
              $('#card_front').val('');
              $('.pplr-quantity > .pplr-drop-item.active').click(); 
            }else if($('.pplr-prev-left').children('img').hasClass('active-back')){
              $('[name="properties[Additional Information]"]').focus();
              var card_back = $('.pplr-prev-left').children('img').attr('src');
              var back_val = $('#card_back');
              if (back_val.val().length < 10) {
                //back_val.val(card_back);
                uploadImage('#card_back',card_back);
                console.log('Back image:', card_back);
              }
              setTimeout(function () {
                var card_front = $('.pplr-prev-left').children('img').attr('src');
                var front_val = $('#card_front');
                if (front_val.val().length < 10) {
                //front_val.val(card_front);
                uploadImage('#card_front',card_front);
                console.log('Front image:', card_front);
                }
              },1500);
            }else{
              $('#card_back').val('');
              $('#card_front').val('');
              $('.pplr-quantity > .pplr-drop-item.active').click(); 
            }
          $('#addToCart').prop('disabled', false);
        } else {
          $('#addToCart').prop('disabled', true);
          $('input[name="properties[Name]"]').focus();
          $('#card_back').val('');
          $('#card_front').val('');
        }
	  });
  }
  // Edwards Chevrolet Page
  else if (path === '/collections/custom/products/edwards-chevrolet') {
    $('input#addToCart').before(acceptBtn);
    $('#addToCart').prop('disabled', true);
    $(document).on('change','input#accept-btn', function() {
        //$('#addToCart').val('Identifying...');
        if ($(this).is(':checked')) {
			    $('.pplr-quantity- > .pplr-drop-item.active').click(); 
         	  setTimeout(() => {
              //$('#addToCart').val('Add to Cart');
              $('#addToCart').prop('disabled', false);
            }, 4000);
        } else {
          //$('#addToCart').val('Add to Cart');
          $('#addToCart').prop('disabled', true);
          $('input[name="properties[Name]"]').focus();
          $('#card_back').val('');
          $('#card_front').val('');
        }
	  });
  }
  // Lloyd Whitehead Gray Monroe Page
  else if (path === '/collections/custom/products/lloyd-whitehead-gray-monroe-business-card') {
    $('input#addToCart').before(acceptBtn);
    $('#addToCart').prop('disabled', true);
    $(document).on('change','input#accept-btn', function() {
        //$('#addToCart').val('Identifying...');
        if ($(this).is(':checked')) {
			    $('.pplr-quantity > .pplr-drop-item.active').click(); 
          setTimeout(() => {
            //$('#addToCart').val('Add to Cart');
            $('#addToCart').prop('disabled', false);
          }, 4000);
        } else {
          //$('#addToCart').val('Add to Cart');
          $('#addToCart').prop('disabled', true);
          $('input[name="properties[Your Name]"]').focus();
          $('#card_back').val('');
          $('#card_front').val('');
        }
	  });
  }
  // Ontime Services Page
  else if (path === '/collections/custom/products/ontime-services-business-cards') {
    $('input#addToCart').before(acceptBtn);
    $('#addToCart').prop('disabled', true);
    $(document).on('change','input#accept-btn', function() {
        //$('#addToCart').val('Identifying...');
        if ($(this).is(':checked')) {
			      $('.pplr-quantity > .pplr-drop-item.active').click(); 
            setTimeout(() => {
              //$('#addToCart').val('Add to Cart');
              $('#addToCart').prop('disabled', false);
            }, 4000);
        } else {
          $('#addToCart').prop('disabled', true);
          //$('#addToCart').val('Add to Cart');
          $('input[name="properties[Your Name]"]').focus();
          $('#card_back').val('');
          $('#card_front').val('');
        }
	  }); 
  }
  else {
    //console.log("🚫 No matching custom script for:", path);
  }
});
